'use client'

import React, { useEffect, useState } from 'react'
import { apmRum } from '@/apm-rum'
import CheckSocialLogin from '@/src/components/misc/check-social-login/check-social-login'
import Pixel from '../helpers/manager-scripts/facebook/pixel'
import Gtm from '../helpers/manager-scripts/google/gtm'
import { useSearchParams } from 'next/navigation'
import FullProduct from '../components/product/full-product/full-product'
import { DB_CACHE_NAME } from '../constants/defaults'
import CacheHelper from '../core/cache/cache-helper'
import { usePromotion } from '../context/promotion/promotion-context'
import { CookieNameEnum } from '../constants/cookie-names'
import { useApplyCouponFromQuery } from '@/src/hooks/useApplyCouponFromQuery'

export default function InitClientScripts() {
    const searchParams = useSearchParams()
    const { promotion } = usePromotion()

    const productId = searchParams.get('q')
    const productName = searchParams.get('name')

    const [canShowModal, setCanShowModal] = useState(false)

    useApplyCouponFromQuery()

    useEffect(() => {
        console.log("APM RUM Initialized:", apmRum)

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'F5' && e.ctrlKey)
                CacheHelper.deleteDatabase(DB_CACHE_NAME)
        }

        window.addEventListener('keydown', handleKeyDown);

        if (productId && productName)
            setCanShowModal(true)

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [])

    useEffect(() => {
        window.setCookieId = function (text: string): void {
            const cookieExists = document.cookie
                .split('; ')
                .find(row => row.startsWith(CookieNameEnum.IdPushNotification))

            if (!cookieExists)
                document.cookie = `${CookieNameEnum.IdPushNotification}=${text}; path=/`
        }
    }, [])

    return (
        <>
            {
                (canShowModal && promotion) &&
                <FullProduct
                    id={productId!}
                    name={productName!}
                    isOpen={true}
                    onClose={() => setCanShowModal(false)}
                />
            }
            <Gtm />
            <Pixel />
            <CheckSocialLogin />
        </>
    )
}
